import api from './api';
import { CONTENT_EXTRACTION_RESTART } from '../configs/routes';

export const restartContentExtraction = (extraction_id) =>
  new Promise((resolve, reject) => {
    api.post(CONTENT_EXTRACTION_RESTART(extraction_id))
      .then((response) => resolve(response.data))
      .catch((err) => reject(err.message));
  }); 